// extracted by mini-css-extract-plugin
module.exports = {"pokemap":"Location_pokemap__2BKMX"};